import { render } from "./ProductModelChangeDialog.vue?vue&type=template&id=444f08e4"
import script from "./ProductModelChangeDialog.vue?vue&type=script&lang=js"
export * from "./ProductModelChangeDialog.vue?vue&type=script&lang=js"

import "./ProductModelChangeDialog.vue?vue&type=style&index=0&id=444f08e4&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QTabPanels,QTab,QTabPanel});
